
const envApiBase = {
  local: "",
  test: 'https://puzzle.snackbook.cc',
  prod: 'https://puzzle.snackbook.cc',
};

const envApiLinkTiktokBase = {
  
  local: 'https://puzzle.snackbook.cc',
  test: 'https://puzzle.snackbook.cc',
  prod: 'https://puzzle.snackbook.cc'
};

export const envResolverTkAPIURL = () => {
  return envApiLinkTiktokBase['prod'];
};

export const envResolverAPIURL = () => {
  return envApiBase['prod'];
};

export const TRACKING_ID = "G-VM90YXVYN8";

export function isTikTokApp() {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.indexOf("tiktok") > -1;
}

export function isIOSSafari() {
  const userAgent = navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(userAgent);
  const isSafari = /Safari/.test(userAgent) && !/Chrome/.test(userAgent);
  return isIOS && isSafari;
}

export function FontFamilyHandle(){
  switch (window.location.hostname){
    case "www.byteflowmedia.com":
    case "byteflowmedia.com":
    case "www.starbrim.xyz":
    case "starbrim.xyz":
      return "Mona Sans Wide";
    default:
      return "Plus Jakarta Sans";
  }
}